

import ReactDOM from 'react-dom/client'
import { getApiContacts } from 'reduxes/slices/api/selectors'
import { TOPICS_FETCH_SIZE } from 'reduxes/slices/topics/actions'

import apiRoutes from '../../../routes/admin_api_routes.json'
import { getRecordsFromApiResponse } from '../../util/api_response_utils'
import { handleApiError } from '../../util/parse_server_error'
import { buildPagedURL, setFetched } from '../api/actions'
import { setAppState } from '../app_state/actions'
import { FIRST_DIRECT_CHATS_FETCH } from '../app_state/reducers'
import { setMatches } from '../paging/actions'

export function createDirectChat(handle, chat) {
  return function (axios, dispatch) {
    const path = apiRoutes.admin_api_v1_direct_chats.path
    return axios().post(path, { handle, chat }).then(
      (result) => {
        dispatch(setFetched('topics', result.data.records))
        return Promise.resolve(result)
      },
      (result) => {
        handleApiError({
          dispatch,
          result,
          path,
        })
        return Promise.reject(result)
      },
    )
  }
}

function getExcludedIds(getState) {
  const state = getState()
  const contacts = getApiContacts(state)
  return getContactSortIds(contacts)
}

function getContactSortIds(contacts) {
  return (
    Object.values(contacts || {})
      .map((contact) => contact.handle)
      .filter((x) => x) || []
  )
}

export function fetchContacts(options = {}) {
  return function (axios, dispatch, getState) {
    options = {
      isFirstFetch: false,
      excluded: undefined,
      ...options,
    }
    const modelName = 'contacts'
    const excluded = options.excluded || getExcludedIds(getState)
    const path = apiRoutes.admin_api_v1_contacts.path
    const url = buildPagedURL(path, {
      limit: TOPICS_FETCH_SIZE,
      filter: { excluded },
    })
    return axios().get(url).then(
      (result) => {
        const contacts = getRecordsFromApiResponse(result, modelName)
        const matches = getContactSortIds(contacts)
        const hasMore = matches.length === TOPICS_FETCH_SIZE

        dispatch(setFetched(modelName, result.data.records))
        if (options.isFirstFetch) {
          dispatch(setAppState(FIRST_DIRECT_CHATS_FETCH, false))
        }
        dispatch(setMatches(modelName, { matches, hasMore }))
        return Promise.resolve({
          excluded: [...excluded, ...matches],
          hasMore,
        })
      },
      (result) => {
        handleApiError({
          dispatch,
          result,
          path,
        })
        return Promise.reject(result)
      },
    )
  }
}
